import { Breadcrumb, Button, Col, Drawer, Flex, Form, Input, Layout, message, notification, Popconfirm, Row, Select, Steps, Table, Tag, theme } from 'antd';
import { FilterOutlined, HomeOutlined, DeleteOutlined, EyeOutlined, EditOutlined, FileWordOutlined } from '@ant-design/icons';
import React, { useState, useRef, useEffect } from 'react';
import GeneralInfo from './GeneralInfo';
import TemplateView from './TemplateView';
import SupportDocs from './SupportDocs';
import Members from './Members';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RequestApproval from '../../../restAPI/RequestApproval';
import { useLocation } from "react-router-dom";

const { Search, TextArea } = Input;
const { Option } = Select;

export default function EditApprovalRequest() {

  const location = useLocation();
  const approvalRequest = location.state; // Retrieve passed props
  console.log(approvalRequest,"approval request passed data")

  const { companyId, token, userCompany, role } = useSelector(state => state.auth);
  const { token: { colorBgElevated, colorBgContainer, borderRadiusLG, colorTextTertiary, colorFillAlter, colorBorder } } = theme.useToken();
  const navigate = useNavigate();
  const generalInfoRef = useRef(null);
  const templateRef = useRef(null);
  const supportdocRef = useRef(null);
  const membersRef = useRef(null);
  const [current, setCurrent] = useState(0);
  const [cercularId, setCercularId] = useState(null);
  const [currentMembers, setCurrentMembers] = useState([]);

  RequestApproval.testWithJWTandCID(companyId, token);
  const [approvalRequestId, setApprovalRequestId] = useState(approvalRequest._id);
  const [generalInfo, setGeneralInfo] = useState({
    branch:approvalRequest.branch?._id ? approvalRequest.branch._id : undefined,
    requesttype: approvalRequest.requestType._id,
    subjectline: approvalRequest.subject,
    message:approvalRequest.message ? approvalRequest.message : undefined
  });
  const [templateView, setTemplateView] = useState(null);
  const [suportDoc, setSuportDoc] = useState([]);
  const [membersdata, setMembersdata] = useState({
    team: {
      name: "",
      companyId: companyId,
      circulationType: approvalRequest.circulationType,
      members: []
    },
    isNewTeam: false,
    selectedTeam: [],
    hocUsers: {}
  });
  const [requestApprovalObj, setRequestApprovalObj] = useState({
    requestTypeId: "",
    subject: "",
    status: approvalRequest.status
  });

  const [api, contextHolder] = notification.useNotification();
  const openNotification = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
    });
  };

  useEffect(() => {
    // console.log(templateView, "templateView update in index");
  }, [templateView]);

  const getuserDetail=async(id)=>{
    const data = await RequestApproval.gettemplateById(id);
    setTemplateView(data.data);

    // console.log(data,"fffffffffff template")
  }
  const setdocumentData=(documents)=>{
    let docs = []
    documents.forEach((element,index) => {
      let obj = {
        id:element._id,
        key:index,
        added:approvalRequest.createdAt,
        path:element.path,
        name:element.name
      }
      docs.push(obj);
    });
    setSuportDoc(docs);
  }
  const setSelectedMembers=async(members)=>{

    let initialMembersData = {...membersdata}
    // let initialMembersData = {
    //   team: {
    //   name: "",
    //   companyId: companyId,
    //   circulationType: approvalRequest.circulationType,
    //   members: []
    //   },
    //   isNewTeam: false,
    //   selectedTeam: [],
    //   hocUsers: {}
    // }
    
    // let membersList = []
    let membersList = members.map((element, index) => {
    
      // console.log(element,"wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww")
      return {
        approverId: element.approver._id,
        _id:element._id,
        approverName: element.approver.name,
        branchId: element.branch?._id ? element.branch._id : undefined,
        hockUserId: element.hockUser?._id ? element.hockUser._id : undefined,
        key: index,
        notification: element.notification,
        permission: element.permission,
        position: element.position
      };
    });
    setCurrentMembers(membersList);
    // console.log(membersList,"111111111111111111111111111111111111111111111")
    let hocuserlist = {}
    for(let user of membersList){
      let hocusers= await gethocusersforId(user.approverId)
      hocuserlist = { ...hocuserlist, [user.approverId]: hocusers };
    }
    initialMembersData.team.members=membersList;
    initialMembersData.hocUsers=hocuserlist;

    setMembersdata(initialMembersData);
    // setSuportDoc(docs);
  }
  
  // const updateHocuserList=async(e)=>{
  //     const list = hocUserLists[e]
  //     console.log(list,"hoc user list")
  //     if(list!==null){
  //         const hocusers = await gethocusersforId(e);

  //         return hocusers;
  //         // setHocUserLists((prevHocUser) => ({
  //         //     ...prevHocUser,   // Keep existing properties
  //         //     [e]: hocusers,  // Dynamically add new property
  //         //   }))
  //     }
  // }
  const gethocusersforId=async(approverId)=>{
        const data =await RequestApproval.getAddHocUsers(approverId)
        .then((response) => {
          const usersList = response.data.map((element) => ({
            id: element.signatoriesId._id,
            name: element.signatoriesId.name,
          }));
          return usersList;
        })
        .catch((error) => {
          console.error("Error fetching users:", error);
          return [] // Handle error by resetting users
        })

        return data
    }
  useEffect(()=>{
    
    if("parentTemplate" in approvalRequest){
      getuserDetail(approvalRequest.parentTemplate._id)
    }
    if(approvalRequest.documents.length>0){
      setdocumentData(approvalRequest.documents);
    }
    if(approvalRequest.approvers.length>0){
      setSelectedMembers(approvalRequest.approvers);
    }
    
  },[])

  

  const steps = [
    {
      title: '',
      content: <GeneralInfo ref={generalInfoRef} setData={setGeneralInfo} savedData={generalInfo} />,
    },
    {
      title: '',
      content: <TemplateView ref={templateRef} setData={setTemplateView} savedData={templateView} />,
    },
    {
      title: '',
      content: (
        <SupportDocs
          ref={supportdocRef}
          setData={setSuportDoc}
          savedData={suportDoc}
          cerculateId={approvalRequestId}
        />
      ),
    },
    {
      title: '',
      content: <Members ref={membersRef} setData={setMembersdata} savedData={membersdata} />,
    },
  ];

  const next = async () => {
    let status = true;
    if (current === 0) {
      const response = await generalInfoRef.current.saveGenaralData();
      status = response.status;
      // console.log(response, "generalInfoRef draft saved object");

      let requestApprovalModel = { ...requestApprovalObj };
      if (response.status) {
        requestApprovalModel.branchId = response.res.branch;
        requestApprovalModel.requestTypeId = response.res.requesttype;
        requestApprovalModel.subject = response.res.subjectline;
        requestApprovalModel.message = response.res.message;

        // let draftsave = await saveRequestApprovel(requestApprovalModel);
        // console.log(draftsave, "draft saved object");

        // if (cercularId === null) {
        //   requestApprovalModel.approvalRequestId = draftsave.res.approvalRequest._id;
        //   setCercularId(draftsave.res.approvalRequest._id);
        // }
        setRequestApprovalObj(requestApprovalModel);
      }
    }
    if (current === 1) {
      const response = templateRef.current.saveTemplateView();
      let requestApprovalModel = { ...requestApprovalObj };

      if (response.res !== null) {
        requestApprovalModel.templateId = response.res._id;
        requestApprovalModel.template = response.res.templateContent;

        setRequestApprovalObj(requestApprovalModel);
        // let draftsave = await saveRequestApprovel(requestApprovalModel);
        // console.log(draftsave, "draft saved object");
      }
    }
    if (current === 2) {
      supportdocRef.current.saveSuportDocs();
    }

    if (status) {
      setCurrent(current + 1);
    }
  };

  const prev = async () => {
    if (current === 1) {
      const response = templateRef.current.saveTemplateView();
      let requestApprovalModel = { ...requestApprovalObj };

      if (response.res !== null) {
        requestApprovalModel.templateId = response.res._id;
        requestApprovalModel.template = response.res.templateContent;

        setRequestApprovalObj(requestApprovalModel);
        // let draftsave = await saveRequestApprovel(requestApprovalModel);
        // console.log(draftsave, "draft saved object");
      }
    }
    if (current === 2) {
      supportdocRef.current.saveSuportDocs();
    }
    if (current === 3) {
      const res = await membersRef.current.saveMembersdata();
      if (res.team.circulationType !== "") {
        let requestApprovalModel = { ...requestApprovalObj };
        requestApprovalModel.circulationType = res.team.circulationType;
        requestApprovalModel.approvers = res.team.members;

        setRequestApprovalObj(requestApprovalModel);
        // await saveRequestApprovel(requestApprovalModel);
      }
    }
    setCurrent(current - 1);
  };

  const handleCirculate = async () => {
    let resutStatus = await membersRef.current.validateWorkflow();
    if (resutStatus.status) {
      // The Popconfirm will handle the confirmation, so we pass the result to handleConfirmAction
      return resutStatus.resultObj; // Return the result to be used in onConfirm
    }
  };

  const handleConfirmAction = async (memberResult) => {
    // debugger
    const finalList = memberResult.team.members.map(item => {
      const match = currentMembers.find(a => a.approverId === item.approverId);
      return match ? { ...item, _id: match._id } : { ...item };
    });

    let requestApprovalModel = { ...requestApprovalObj };
    requestApprovalModel.circulationType = memberResult.team.circulationType;
    requestApprovalModel.approvers = finalList;

    // const resultOfDraft = await saveRequestApprovel(requestApprovalModel); // First create draft

    // requestApprovalModel.status = "active";

    console.log(JSON.stringify(requestApprovalModel), "requestApprovalModel creating object");

    // const result = false;
    const result = await saveRequestApprovel(requestApprovalModel,approvalRequest._id);

    if (result.status) {
      // message.success('Approval Request Updated Successfully!');
      openNotification('success', 'Success', `Approval Request Updated Successfully!`, 'bottomLeft');

      if (memberResult.isNewTeam) {
        await RequestApproval.createTeam(memberResult.team)
          .then((response) => {
            // message.success('Team Created Successfully!');
            openNotification('success', 'Success', `Team Created Successfully`, 'bottomLeft');
          })
          .catch((err) => {
            if (err.response) {
              // message.error(`${err.response.data.message}`);
              openNotification('error', 'Error', `${err.response.data.message}`, 'bottomLeft');
            } else {
              // message.error('Team Creation Failed!');
              openNotification('error', 'Error', `Team Creation Failed`, 'bottomLeft');
            }
          });
      }
      navigate('/work-flow/circuler');
    }
  };

  const saveRequestApprovel = async (object,id) => {
    try {
      const data = await RequestApproval.updateRequestApproval(object,id);
      console.log(data, "saveRequestApproval success response");
      return { status: true, res: data.data };
    } catch (err) {
      if (err.response) {
        // message.error(`${err.response.data.message}`);
        openNotification('error', 'Error', `${err.response.data.message}`, 'bottomLeft');
      } else {
        // message.error('saveRequestApproval Creation Failed!');
        openNotification('error', 'Error', `saveRequestApproval Creation Failed!`, 'bottomLeft');
      }
      return { status: false, res: null };
    }
  };

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    marginTop: 16,
    marginBottom: 96,

  };

  return (
    <>
    {contextHolder}
      <Flex gap={20} justify='space-between' align='center' style={{
        margin: '16px',
        padding: '16px 24px',
        background: colorBgContainer,
        borderRadius: borderRadiusLG,
      }}>
        <Breadcrumb
          items={[
            {
              href: '',
              title: <FileWordOutlined />,
            },
            {
              title: 'Workflow / Request Approval',
            },
          ]}
        />
      </Flex>
      <div style={{
        margin: '16px',
        padding: 24,
        background: colorBgContainer,
        borderRadius: borderRadiusLG,
      }}>
        <Steps current={current} items={items} size='small' />
      </div>
      <div style={{
        margin: '16px',
        borderRadius: borderRadiusLG,
      }}>
        <div style={contentStyle}>
          {steps[current].content}
        </div>
      </div>
      <Flex align='center' justify='flex-end' gap={16} style={{
                        width: 'calc(100% - 80px)',
                        paddingLeft: 8,
                        paddingRight: 12,
                        paddingTop: 16,
                        paddingBottom: 16,
                        borderTop: `1px solid ${colorBorder}`,
                        backgroundColor: colorBgElevated,
                        position: 'absolute',
                        bottom: 0,

                    }}>
        {current > 0 && (
          <Button
            style={{ margin: '0 8px' }}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}
        {current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
        {current === steps.length - 1 && (
          <Popconfirm
            title="Create Request Approval"
            description="Are you sure you want to circulate this approval request?"
            onConfirm={async () => {
              const result = await handleCirculate();
              if (result) {
                await handleConfirmAction(result);
              }
            }}
            onCancel={() => {
              // message.info('Circulation cancelled');
            openNotification('info', 'Info', `Circulation Cancelled`, 'bottomLeft');

            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary">
              Update Circulate
            </Button>
          </Popconfirm>
        )}
      </Flex>
    </>
  );
}